// extracted by mini-css-extract-plugin
module.exports = {"container":"CommunityDashboardPage_container__dKGJJ","title":"CommunityDashboardPage_title__z5E3x"};